import React, { useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { PagePopup as PagePopupCore } from '@core/js/components/system/Page/components/PagePopup/PagePopup';

export * from '@core/js/components/system/Page/components/PagePopup/PagePopup';

export const PagePopup = ({ page, isLoading }) => {
    const [isShowAsModal, setIsShowAsModal] = useState(Boolean(page.isShowAsModal));

    useEffect(() => {
        const handleToggleModalMode = (toggle) => {
            setIsShowAsModal(toggle);
        };

        dispatcher.listen('pagePopup:toggleModalMode', handleToggleModalMode);

        return () => {
            dispatcher.removeListener('pagePopup:toggleModalMode', handleToggleModalMode);
        };
    }, []);

    return (
        <PagePopupCore
            page={{ ...page, isShowAsModal }}
            isLoading={isLoading}
        />
    );
};
